import React from "react";
import { SurveySegment, getSegmentListKey } from "../../../../../../amorg-common";
import { SegmentationViewMode } from "../../../../../../utils/amorgLocalStorage";
import { SegmentListView } from "./SegmentListView";


type ReadOnlySegmentPanelProps = {
    segmentLists:SurveySegment[][],
    wrapInCard?:boolean,
    displayAnswerCount?:boolean,
    lockedView?:SegmentationViewMode,
};

export function ReadOnlySegmentPanel (props: ReadOnlySegmentPanelProps): JSX.Element 
{
    const segmentLists = React.useMemo(()=>
        props.segmentLists.map(sl => ({
            segments: sl,
            answerCount:0,
            identifier: getSegmentListKey(sl),
            selected: true
        }))
    , [props.segmentLists]);

    return (
        <>
            <SegmentListView
                view={props.lockedView}
                segmentLists={segmentLists}
                displayAnswerCount={props.displayAnswerCount}
                wrapInCard={props.wrapInCard} />
        </>
    );
}